import React from 'react'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import PromotionDrawer from './components/PromotionDrawer'
import * as Styled from './PromotionLink.styles'

class PromotionLink extends React.Component {
  constructor(props) {
    super(props)
    this.state = { show: false }
  }

  toggleDrawer = () => this.setState({ show: !this.state.show })

  onClickLink = () => {
    pushEventAndTrack({
      eventInfo: {
        eventAction: 'PDP Nectar Points Side Drawer Open',
        eventName: 'pdp_nectarPointsSideDrawerOpen'
      }
    })
  }

  render = () => {
    const { show } = this.state

    const toggle = () => this.toggleDrawer()
    const { partNumber, name, promotions } = this.props

    if (!promotions || promotions === {}) return null

    const reducer = (accumulator, current) => accumulator + current.value
    const nectarPoints = promotions.reduce(reducer, 0)

    if (nectarPoints === 0) return null

    const promotionDrawerOptions = {
      partNumber,
      name,
      promotions,
      totalNectarPoint: nectarPoints,
      dataTest: 'promotion-drawer'
    }

    return (
      <>
        <Styled.Container
          onClick={toggle}
          onKeyPress={toggle}
          id='promotion-link'
          role='link'
          tabIndex='0'
          data-test='promotion-drawer-link'
        >
          <Styled.Label>
            <Styled.LabelImage
              src='https://media.4rgos.it/i/Argos/NectarNew'
              width='24'
              height='20'
              data-test='nectar-points-label-image'
              alt='nectar-image'
            />
            <Styled.LabelContentWrapper>
              <div data-test='promotion-drawer-link-text'>
                Collect <b>{nectarPoints} Nectar</b> points
              </div>
              <Styled.Link data-test='promotion-drawer-link-info-text' onClick={this.onClickLink}>
                Find out more
              </Styled.Link>
            </Styled.LabelContentWrapper>
          </Styled.Label>
        </Styled.Container>
        <PromotionDrawer show={show} togglePromotionDrawer={this.toggleDrawer} {...promotionDrawerOptions} />
      </>
    )
  }
}

export default PromotionLink
